import React from 'react';
import '../App.less';
import { Link } from "react-router-dom";
import { 
    Button,
    Image,
    Typography, 
    Divider, 
    Statistic,
    Tag,
    Row, 
    Col,
    Space,
    PageHeader,
    Avatar,
    Alert
} from 'antd';

import { AntDesignOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;



function chromoskyn() {
  return (
    <div>
        <Row className="m48-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                
                    <Row className="m24-b">
                        <Link to="/">
                            <PageHeader
                                onBack={() => null}
                                title="Back to Home"
                            />
                        </Link>
                    </Row>

                    <Row className="m16-b">
                        <Title>Chromoskyn</Title>
                    </Row>

                    <Row className="m24-b m24-t">
                        <Text>
                            With rapid industrialization and growth of big cities, human’s disconnection from nature and the rise of climate-related issues have increased. This design concept explores the augmentation of individuals with organic material to re-establish this forgotten sense of our connection with nature to experience the world in distress. This project works in the area of sensing earth, sensual computing, and speculative design.
                        </Text>  
                    </Row>

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Advisors</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/yeahs/" target="_blank" rel="noopener noreferrer">Yasaman Sheri</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Team</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/acevedoana01/" target="_blank" rel="noopener noreferrer">Ana Acevedo</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/mohit-choudhary-75244447/" target="_blank" rel="noopener noreferrer"> Mohit Choudhary</a>, 
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/omar-razo-a837291/" target="_blank" rel="noopener noreferrer"> Omar A. Razo</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Sustainable development goals</Text>
                                <Space className="m8-t">
                                    <Image className="sdgImage" src={`../pubAssets/sdg-3.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-11.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-12.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-13.png`}/>
                                </Space>
                                <Space className="m8-t">
                                    <Image className="sdgImage" src={`../pubAssets/sdg-15.png`}/>
                                </Space>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Tags</Text>
                                <Space size={1}>
                                    <Tag>Processing</Tag>
                                    <Tag>Projection Map</Tag>
                                </Space>
                                <Space size={1}>
                                    <Tag>API</Tag>
                                    <Tag>CIID</Tag>
                                </Space>
                            </Space>
                        </Col>
                    </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>


        <Row>
            <Col span={24}>
                    <div className="videoHeight">
                        <iframe src="https://player.vimeo.com/video/476164393?title=0&byline=0&portrait=0" className="vimeoChild" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                    </div>
            </Col>  
        </Row>
        
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle">challenge</Text>
                            <Text>
                                Design an interface that highlights the emerging connections to the ecological & biological reality.
                                <br/>
                                <br/>
                                We were given 4 topics to work with:
                                <div className="m16-t">
                                    <ul>
                                        <li><strong>Sensing Earth</strong> - Design at the planetary scale</li>
                                        <li><strong>Inter-species Perception</strong> - Design Communication with lifeforms</li>
                                        <li><strong>Invisible Materiality</strong> - Design Olfaction & the Micro-biome</li>
                                        <li><strong>Sensual Computer</strong> - Design Soft Interfaces</li>
                                    </ul>   
                                </div>
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle">outcome</Text>
                            <Text>
                                Chromoskyn is a living organic tattoo that represents the greenhouse gas level in the city. The color and shape of Chromoskyn changes in response to the level of carbon dioxide & other greenhouse gases in the vicinity. It helps us visualize in real-time the air quality of our environment and our impact on the same. This in turn, helps us develop our connection and empathy for our environment.
                                <br/><br/>
                                The Chromoskyn tattoo lives in a symbiotic relationship with the user, it is made of carbon-phylic seeds and water-based glue. It feeds on the body chemistry, skin composition, body fluids, and temperature imparting a unique characteristic for each individual. This Chromoskyn tattoo can be placed anywhere in the body like any other tattoo. Since it’s a living tattoo, it will keep growing and morphing. The user has the option to remove a part of it or entirely and plant it on a tree to continue its growth.
                            </Text>
                        </Space>
                    </Col>
                </Row>
                
                <Row className="m80-t">
                    <Image src={require("../assets/projects/chromoskyn/chromoskyn_1.png")}
                            placeholder={
                                <Image src="http://ciid.dk/root_ciidwww/wp-content/uploads/2020/06/1-17-1024x768.jpg?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200"/>
                            }
                        />
                    <div  className="m16-t">
                        <Text>
                            We were inspired by Cyborg artists expanding their sensing capabilities for a better living and symbiotic relationships in nature. When we think about climate change, global warming, international and global distant connections & the many species that inhabit the world, we lack creative and poetic ways of engaging.
                            <br/><br/>
                            The goal was to inspire, prototype and imagine interactions and embodiments of technology that we actually want to live in and to work together to create the next few years of design. We will use our tools of hardware and software prototyping, video prototyping, sketching, photography, micro interactions to give shape to our ideas.
                        </Text>
                    </div>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        
        <Row className="whiteBG">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row className="m80-t m16-b"><Title className="whiteBGTitle">Bodystorming</Title></Row>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <Space direction="vertical">
                            <Text  className="whiteBGTitle">
                                Our main theme is the concept of disbalance caused by humans in the natural environment. We explored disbalance to individual in many formats such as physical disbalance by joining legs, cognitive load by giving puzzles to solves while walking criss-cross, aural disbalance by clapping impromptu to someone’s ear, and space discomfort by enacting a CO2 molecule.
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                        <Image src={require("../assets/projects/chromoskyn/chromoskyn_5.gif")}/>
                    </Col>
                </Row>
                <Row className="m16-t">
                    <Space size={16}>
                        <Image src={require("../assets/projects/chromoskyn/chromoskyn_6.gif")}/>
                        <Image src={require("../assets/projects/chromoskyn/chromoskyn_7.gif")}/>
                    </Space>
                </Row>
                <Row className="m48-t m80-b">
                    <Text className="whiteBGTitle m16-b">
                        Based on our learnings, we came up with the Chromoskyn concept:
                    </Text>
                    <Text className="HMW" >
                        Living organic tattoos that represent air quality in your city
                    </Text>                 
                </Row>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <div>
                            <Image src={require("../assets/projects/chromoskyn/chromoskyn_2.png")}/>
                            <div  className="m16-t">
                                <Text className="whiteBGTitle">
                                    Non-invasive application of the tattoo
                                </Text>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <div>
                            <Image src={require("../assets/projects/chromoskyn/chromoskyn_3.png")}/>
                            <div  className="m16-t">
                                <Text className="whiteBGTitle">
                                    Atmospheric factors which influence the growth from the seeds
                                </Text>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Image src={require("../assets/projects/chromoskyn/chromoskyn_4.png")}/>
                    </Col>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row>
                    <Title>Prototyping</Title>
                </Row>
                <Row className="m16-t">
                    <Text>
                        We proceeded by exploring low-fi prototypes of producing disbalance through affecting the equilibrium of the inner ear by giving audio feedback to the ear. Our mid-fi prototype included using P5.JS and WeatherAPI to explore real-time projection on the body using Kinect to explore the sensation of feeling pollution on the body.
                    </Text>
                </Row>
                <Row className="m48-t m80-b"justify="space-between" >
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/chromoskyn/chromoskyn_8.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    mid-fi prototype to get an idea of how it feels when pollution is reflected on my body.
                                </Text>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/chromoskyn/chromoskyn_9.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Makeup stickers used to prototype chromoskyn tattoo
                                </Text>
                            </div>
                        </div>
                    </Col>             
                </Row>
                

                <Row className="m48-b">
                    <Col span={24}>
                            <div className="videoHeightIn">
                                <iframe src="https://player.vimeo.com/video/523540189?title=0&byline=0&portrait=0" className="vimeoChild" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            </div>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    A window into the life of an cyberartist ;)
                                </Text>
                            </div>
                    </Col>  
                </Row>

                <Row>
                    <Text className="projectTitle">Learnings from prototype</Text>
                </Row>

                <Row justify="space-between m16-t">
                    <Col span={24}>
                        <Space size={4} direction="vertical">
                            <Text>
                                <ul>
                                    <li>Committing to something completely out of the public eye, will make one seem crazy, no matter how logical the reasoning may be.</li>
                                    <li>After exploring and sitting with those concepts, the term ‘crazy’ will be replaced by terms like, ‘accepted’ or ‘admirable’.</li>
                                    <li>Living with the intervention is important to understand subtle effects in behaviour and lifestyle</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>

            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
    </div>
  );
}

export default chromoskyn;